import SidebarLayout from '../../layouts/RootLayout.js';
export const CallbackPage = () => {
	return (
		<div className="page-layout">
			<SidebarLayout/>
			<div className="page-layout__content" />
		</div>
	);
};